import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/roth-traditional-ira',
  component: () => import('../../routes/RothTraditionalIra.svelte'),
  card: {
    id: 'roth-traditional-ira',
    title: 'Roth vs Traditional IRA',
    description: 'Compare Roth and Traditional IRA contributions to find the better tax strategy for your situation.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/roth-traditional-ira',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Roth vs Traditional IRA Calculator – Compare Tax Strategies',
    description: 'Compare Roth IRA vs Traditional IRA contributions. See which strategy saves you more based on your current and retirement tax rates, growth rate, and time horizon.',
  },
};

export default meta;